import React from 'react';
import {Line} from 'react-chartjs-2';

const initialState = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July','Aug',
  'Sep','Oct','Nov','Dec'],
  datasets: [
    {
      label: 'Product code A501C Sales',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      // data: [49, 59, 40, 81, 56, 75, 90]
      // data: [10, 30, 10, 30, 60, 75, 90, 49, 10, 40, 81, 60, 75, 90]
      data: [32, 1, 22, 33, 98, 60, 23, 97, 72, 94, 71, 38]

    }
  ]
};
const options = {
  maintainAspectRatio: false
}

let interval_

class RandomizedLineYear extends React.Component {
//const  = React.createClass({
	// displayName: 'Graph',
	componentWillMount(){
		this.setState(initialState);
  } 
  
	componentDidMount(){

		var _this = this;

		interval_ = setInterval(function(){
			var oldDataSet = _this.state.datasets[0];
			var newData = [];
      var ProdNameLable = `Product code A5${Math.floor(Math.random() * 100)}C Sales`
			for(var x=0; x< _this.state.labels.length; x++){
				newData.push(Math.floor(Math.random() * 100));
			}

			var newDataSet = {
        ...oldDataSet
      };

     
      // console.log(newDataSet)
      newDataSet.data = newData;
      newDataSet.label = ProdNameLable;

			var newState = {
				...initialState,
				datasets: [newDataSet]
			};

			_this.setState(newState);
		}, 5000);
  }

  componentWillUnmount(){
    clearInterval(interval_)
  }
  
	render() {
		return (
      
      <div style={{
        display: 'flex',
        flex: 1,
        height: '100%',
        overflowX: 'hidden'
    }}>
			<Line data={this.state}  options={options}/>
      </div>
     

		);
	}
};

export default  RandomizedLineYear



